(function () {
    'use strict';

    angular.module("imApp").factory("shipmentContainerService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 774,
                    parameters: parms || {}
                });
            },
            listStockLocations: function (parms) {
                return $ihttp.post({
                    method: 1029,
                    parameters: parms || {}
                });
            },
            listContents: function (parms) {
                return $ihttp.post({
                    method: 777,
                    parameters: parms || {}
                });
            },
            createObj: function (edit) {
                return $ihttp.post({
                    method: 775,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
